<!--
 * @Description: 个人中心
--> 
<template>
  <div class="person-center">
    <!-- <van-nav-bar
      v-show="$topBar"
      :title="$route.meta.title"
      fixed
      >
    </van-nav-bar>
    <div v-show="$topBar" class="comm-topbar-height"></div> -->
    <div class="mine-content">
      <!-- <van-icon name="scan" /> -->
      <div style="padding: 10px;height: 22px;"></div>
      <div class="banner">
        <!-- <div style="height:25px;"></div> -->
        <div class="avatar">
          <img v-if="avatar" :src="avatar" />
          <img v-else :src="require('../../assets/images/default.png')">
        </div>
        <div class="username">{{nickname?nickname:''}}</div>
      </div>
      <div class="main">
        <div class="main-wrapper">
          <div class="main-content">
            <div class="main-item" v-for="(menu, i) in personMenus" :key="i" @click="menuClick(menu)">
              <span class="main-item-txt">
                <img v-if="menu.name === '绑定信息'" :src="menu.icon" alt="" width="30" style="margin: 0 3px">
                <img v-else :src="menu.icon" alt="" width="17">
                <span>{{menu.name}}</span>
              </span>
              <span class="iconfont iconshang"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <home-bar></home-bar>
    <div class="comm-homebar-height"></div>
  </div>
</template>

<script>
import HomeBar from '@/components/HomeBar.vue'
export default {
  name: 'PersonCenter',
  components: {
    HomeBar
  },
  data() {
    return {
      nickname: localStorage.getItem('nickname'),
      avatar: localStorage.getItem('avatar'),
      personMenus: [
        {
          icon: require('../../assets/images/mine01.png'),
          name: '个人信息',
          path: '/mine/registerInfo',
        },
        // {
        //   icon: 'iconmima',
        //   name: '密码修改',
        //   path: '/mine/pwdModify'
        // },
        {
          icon: require('../../assets/images/mine02.png'),
          name: '绑定信息',
          path: 'bindManage'
        },
        {
          icon: require('../../assets/images/mine03.png'),
          name: '业务办理',
          path: '/mine/businessProgress?active=0'
        },
        // {
        //   icon: 'iconjindu',
        //   name: '客户服务工单查询',
        //   path: '/mine/butlerProgress?active=0'
        // },
        // {
        //   icon: require('../../assets/images/mine04.png'),
        //   name: '电子合同',
        //   path: '/mine/elecContract'
        // },
        // {
        //   icon: 'iconjiaofeijilu',
        //   name: '工程款缴费记录',
        //   path: '/mine/payRecords'
        // },
        // {
        //   icon: 'iconwangshangchaobiaopaizhaogongneng',
        //   name: '网上抄表记录',
        //   path: '/mine/readRecords'
        // }
        // {
        //   icon: require('../../assets/images/mine05.png'),
        //   name: '水表检定结果',
        //   path: '/mine/shuibiaojiandingjieguo'
        // },
        // {
        //   icon: require('../../assets/images/mine06.png'),
        //   name: '水质检测报告',
        //   path: '/mine/shuizhijiancebaogao'
        // },
        {
          icon: require('../../assets/images/mine07.png'),
          name: '报修信息',
          path: '/mine/baoxiuxinxi'
        },
        {
          icon: require('../../assets/images/mine08.png'),
          name: '投诉建议',
          path: '/mine/tousujianyi'
        },
        {
          icon: require('../../assets/images/mine09.png'),
          name: '违章举报',
          path: '/mine/weizhangjubao'
        },
        // {
        //   icon: require('../../assets/images/mine10.png'),
        //   name: '安全退出',
        //   path: ''
        // }
      ]
    }
  },
  mounted() {
  },
  methods: {
    menuClick(menu) {
      if (!menu.path) {
        this.$toast('待配置')
        return
      }
      if (menu.name === '绑定信息') {
        this.$comm.bindManage()
        return
      }
      this.$router.push({
        path: menu.path
      })
    },
  },
}
</script>

<style lang="less" scoped>
.person-center {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  .mine-content {
    overflow: auto;
    position: relative;
    z-index: 2;
    width: 100%;
    /deep/.van-icon-scan {
      color: #fff;
      font-size: 22px;
      padding: 10px;
    }
    .banner {
      background-color: #fff;
      width: 80%;
      border-radius: 6px;
      margin: 10px auto;
      padding: 10px;
      .avatar {
        img {
          display: block;
          margin: 0 auto;
          width: 46px;
          height: 46px;
          border-radius: 50%;
        }
      }
      .username {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #333;
        margin-top: 9px;
        display: block;
        text-align: center;
      }
    }
    .main {
      box-shadow: 0px 4px 10px 0px rgba(53, 126, 70, 0.08);
      border-radius: 4px;
      padding-bottom: 60px;
      .main-wrapper {
        // padding: 0 13px;
        .main-content {
          .main-item {
            background: #ffffff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e5e5e5;
            height: 44px;
            .main-item-txt {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333;
              display: flex;
              align-items: center;
              img {
                margin: 0 8px;
              }
            }
            .iconfont {
              color: #c7c7c7;
              margin-right: 8px;
            }
            /deep/.iconshang {
              display: inline-block;
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
}
.person-center::before {
  content: "";
  top: -10%;
  bottom: 80%;
  left: -20px;
  right: -20px;
  position: fixed;
  z-index: 1;
  border-radius: 50%;
  background-color: #4796e3;
}
</style>